import dynamic from 'next/dynamic';
import { CarouselProvider as Provider } from 'pure-react-carousel';
import React from 'react';

// import css dynamically (via js) as opposed to a prioritized <Link> tag
const CSS = dynamic(() => import('./Carousel.styles'), {
  ssr: false
});

interface ICarouselProviderProps {
  naturalSlideWidth: number;
  naturalSlideHeight: number;
  numTotalSlides: number;
  numVisibleSlides: number;
  children: any;
  currentSlide?: number;
}

const CarouselProvider: React.FC<ICarouselProviderProps> = ({
  naturalSlideWidth,
  naturalSlideHeight,
  numTotalSlides,
  numVisibleSlides,
  children,
  currentSlide
}) => (
  <Provider
    naturalSlideWidth={naturalSlideWidth}
    naturalSlideHeight={naturalSlideHeight}
    totalSlides={numTotalSlides}
    visibleSlides={numVisibleSlides}
    step={1}
    infinite
    currentSlide={currentSlide}
  >
    <CSS />
    {children}
  </Provider>
);

export default CarouselProvider;
